"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var ViewStudentDetailsModalController = /** @class */ (function () {
    function ViewStudentDetailsModalController($uibModalInstance, student, UsersModel) {
        var _this = this;
        this.$uibModalInstance = $uibModalInstance;
        this.UsersModel = UsersModel;
        this.student = {};
        this.nextSession = {};
        this.hasNextSession = false;
        this.loading = true;
        UsersModel.getStudentByID(student.id).then(function (response) {
            //this.student = response.student;
            if (response.usermeta.permit) {
                response.usermeta.permit.issuedate = (0, moment_1.default)(response.usermeta.permit.issuedate).toDate();
                response.usermeta.permit.expirationdate = (0, moment_1.default)(response.usermeta.permit.expirationdate).toDate();
            }
            /* @ts-ignore */
            response.school.address = JSON.parse(response.school.address);
            var student = response;
            _this.student = student;
            _this.loading = false;
            _this.getNextSession();
        }).catch(function (error) {
            _this.loading = false;
        });
    }
    ViewStudentDetailsModalController.prototype.cancel = function () {
        this.$uibModalInstance.dismiss('cancel');
    };
    ViewStudentDetailsModalController.prototype.getNextSession = function () {
        var _this = this;
        this.UsersModel.getNextStudentEntity({ 'id': this.student.id }).then(function (response) {
            if ((0, isEmpty_1.default)(response.entity)) {
                _this.nextSession = {};
                _this.hasNextSession = false;
            }
            else {
                _this.nextSession = {
                    'nextDrive': response.entity,
                    'nextDriveDate': (0, moment_1.default)(response.entity.date + ' ' + response.entity.time),
                    'untilDrive': (0, moment_1.default)(response.entity.date + ' ' + response.entity.time).format('h:mm a')
                };
                _this.hasNextSession = true;
            }
        });
    };
    return ViewStudentDetailsModalController;
}());
ViewStudentDetailsModalController.$inject = ['$uibModalInstance', 'student', 'UsersModel'];
exports.default = ViewStudentDetailsModalController;
